import React from "react";

/**
 * Melopa Invents logo wrapper.
 *
 * `tone`:
 *   - 'auto'  (default) - black logo on its own (best on white surfaces)
 *   - 'pill'  - black logo inside a white pill (use on dark backgrounds for clean look)
 */
export default function Logo({ size = 36, tone = "auto", className = "" }) {
  if (tone === "pill") {
    return (
      <span
        className={`inline-grid place-items-center bg-white rounded-lg shadow-sm ${className}`}
        style={{ width: size + 6, height: size + 6, padding: 3 }}
      >
        <img
          src="/melopa-logo.png"
          alt="Melopa Invents"
          width={size}
          height={size}
          className="object-contain"
          style={{ width: size, height: size }}
        />
      </span>
    );
  }
  return (
    <img
      src="/melopa-logo.png"
      alt="Melopa Invents"
      width={size}
      height={size}
      className={`object-contain select-none ${className}`}
      style={{ width: size, height: size }}
      draggable={false}
    />
  );
}
